/**
 * Runtime environment configuration.
 * Single source: window.__ENV__ from public/config.js (loaded before app in index.html).
 */

export interface RuntimeEnv {
  NODE_ENV: string;
  VITE_API_BASE_URL: string;
  VITE_APP_NAME: string;
  VITE_APP_URL: string;
  VITE_PLATFORM_NAME: string;
}

declare global {
  interface Window {
    __ENV__?: RuntimeEnv;
  }
}

/** Defaults when window.__ENV__ is not available (e.g. SSR or before config.js loads) */
const getDefaultEnv = (): RuntimeEnv => ({
  NODE_ENV: typeof import.meta !== 'undefined' && import.meta.env?.MODE ? import.meta.env.MODE : 'production',
  VITE_API_BASE_URL: 'https://admin-fourd.shay-ai.com/api',
  VITE_APP_NAME: 'Prism 7',
  VITE_APP_URL: 'https://app-fourd.shay-ai.com/',
  VITE_PLATFORM_NAME: 'prism7',
});

/**
 * Get runtime environment variables from config.js (window.__ENV__).
 * Fallback to defaults only when __ENV__ is not set.
 */
export const getRuntimeEnv = (): RuntimeEnv => {
  if (typeof window === 'undefined' || !window.__ENV__) {
    return getDefaultEnv();
  }
  // config.js is the single source; fill missing keys with defaults
  return { ...getDefaultEnv(), ...window.__ENV__ };
};
